import { AutogenModelMacropointControl, AutogenRowMacropointControl } from "./autogen/AutogenModelMacropointControl";

export class ModelMacropointControl extends AutogenModelMacropointControl<RowMacropointControl> {
	constructor() {
		super(RowMacropointControl);
	}
}

export class RowMacropointControl extends AutogenRowMacropointControl {
}